exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.right-menu-item .el-badge .is-fixed {\n  right: 10px;\n  top: 15px\n}\n#notice .el-badge .is-fixed {\n  top: 17px;\n  right: 6px;\n}\n", ""]);

// exports
